import React from 'react';
import SEO from '../components/SEO';

const accommodations = [
  {
    id: 1,
    name: "Sharda University Guest House",
    location: "Plot No. 32-34, Knowledge Park III, Greater Noida, Uttar Pradesh 201310",
    image: "https://admissions.sharda.ac.in/phd/img/sharda.webp",
    description: "Sharda University's campus in Greater Noida is a fully residential, self-contained campus. While the university provides extensive on-campus residential facilities for students, specific details about a dedicated guest house or visitor accommodation are not available in our current records. For the most accurate and up-to-date information about guest house availability, booking procedures, and tariffs, we recommend reaching out to the university directly.",
  },
  {
    id: 2,
    name: "Hostel & Accommodation at Sharda University",
    location: "Plot No. 32-34, Knowledge Park III, Greater Noida, Uttar Pradesh 201310",
    image: "https://sustainability.sharda.ac.in/assets/hero-image.png",
    description: "Sharda University offers comfortable, safe, and well-supervised residential accommodation for both male and female students on its 63-acre campus in Greater Noida.",
  },
  {
    id: 3,
    name: "IIT Roorkee Greater Noida Center (GNEC) Accommodation",
    location: "FF7R+GW9, GNEC-IITRoorkee, Plot No. 20, Knowledge Park II, Greater Noida, Uttar Pradesh 201310",
    image: "https://www.iitr.ac.in/cvip2017/images/gnec_campus/13.jpg",
    description: "Comfortable and affordable stay right on the university campus for quick access to the conference venue.",
  },

];

const Accommodation = () => {
  return (
    <>
      <SEO 
        title="Accommodation" 
        description="Find suitable accommodation options for your stay during the NCLC-2026 conference." 
      />
      <div className="min-h-screen bg-[#f8f9fa] py-16 pt-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl uppercase underline font-bold text-[#1e1b4b] mb-4 tracking-wide">
              Accommodation
            </h1>
           
          </div>

          {/* Cards Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {accommodations.map((hotel) => (
              <div 
                key={hotel.id} 
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col"
              >
                {/* Image */}
                <div className="w-full h-48 sm:h-56 overflow-hidden relative">
                  <img 
                    src={hotel.image} 
                    alt={hotel.name} 
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                {/* Content */}
                <div className="w-full p-6 flex flex-col flex-grow justify-between">
                  <div>
                    <h3 className="text-2xl font-bold text-[#1e1b4b] mb-2">{hotel.name}</h3>
                    
                    {/* Location with Icon */}
                    <div className="flex items-start text-gray-500 mb-3">
                      <svg className="w-5 h-5 mr-1 mt-0.5 text-indigo-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z"></path>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      </svg>
                      <span className="text-sm">{hotel.location}</span>
                    </div>
                    
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {hotel.description}
                    </p>
                  </div>
                  
                 
                </div>
              </div>
            ))}
          </div>

          {/* Booking Info Box */}
          <div className="bg-white rounded-xl shadow-sm border border-indigo-100 p-8 text-center max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-[#1e1b4b] mb-3">Need help with accommodation?</h2>
            <p className="text-gray-600 mb-6">
              For submitting details regarding accommodation requests, please click the button below. The form will be available shortly.
            </p>
            <button className="bg-[#1f2e6d] text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-800 transition-colors shadow-md cursor-not-allowed opacity-80" disabled>
              Request Accommodation (Coming Soon)
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accommodation;
